module.exports = __webpack_public_path__ + "img/sum-bet-btn-active.a185116b.svg";